import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

const SkeletonLoader = ({ count = 8 }) => {
  return (
    <Grid container spacing={2}>
      {Array.from(new Array(count)).map((_, index) => (
        <Grid item xs={6} sm={4} md={3} key={index}>
          <Box textAlign="center" sx={{
            padding: '12px',
            position: 'relative',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: 2,
          }}>
            <Skeleton variant="rectangular" width="100%" height={180} sx={{ borderRadius: 2 }} />
            <Skeleton variant="text" sx={{ mt: 1, width: '80%', mx: 'auto' }} />
            <Skeleton variant="text" sx={{ mt: 1, width: '60%', mx: 'auto' }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default SkeletonLoader;
